module.exports = __webpack_public_path__ + "img/pellets-truck.d1c0463.png";